import { keyValueList } from "../fable_modules/fable-library-js.4.18.0/MapUtil.js";

export function toProps(props) {
    return keyValueList(props, 1);
}

